import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
const comparisons = [{
  bad: 'Falta de energía diaria',
  good: 'Más vitalidad y motivación'
}, {
  bad: 'Rutinas abandonadas',
  good: 'Constancia real'
}, {
  bad: 'Baja autoestima',
  good: 'Más confianza personal'
}, {
  bad: 'Sedentarismo',
  good: 'Hábitos saludables'
}, {
  bad: 'Estrés y cansancio',
  good: 'Mejor bienestar mental'
}, {
  bad: 'Confusión sobre qué hacer',
  good: 'Sistema simple paso a paso'
}, {
  bad: 'Falta de disciplina',
  good: 'Organización y enfoque'
}, {
  bad: 'Siempre empezar de cero',
  good: 'Progreso sostenible'
}];
const results = ['Más energía', 'Mejor estado físico', 'Mayor disciplina', 'Mejor autoestima', 'Hábitos saludables sólidos', 'Más confianza y bienestar'];
export function ComparisonTable() {
  return <section className="py-24 px-4 bg-dark" data-id="element-56">
      <div className="max-w-4xl mx-auto" data-id="element-57">
        <div className="text-center mb-16" data-id="element-58">
          <h3 className="text-brand font-bold tracking-widest uppercase mb-4" data-id="element-59">
            LA REALIDAD
          </h3>
          <h2 className="text-5xl md:text-6xl font-display uppercase text-white" data-id="element-60">
            ¿CUÁNTO CUESTA NO CAMBIAR?
          </h2>
        </div>

        <div className="bg-dark-card border border-dark-border rounded-2xl overflow-hidden mb-16" data-id="element-61">
          <div className="grid grid-cols-2 bg-black border-b border-dark-border" data-id="element-62">
            <div className="p-6 text-center border-r border-dark-border" data-id="element-63">
              <h4 className="font-display text-2xl text-gray-400 uppercase" data-id="element-64">
                SIN EL SISTEMA <span className="text-red-500" data-id="element-65">❌</span>
              </h4>
            </div>
            <div className="p-6 text-center bg-brand/5" data-id="element-66">
              <h4 className="font-display text-2xl text-brand uppercase" data-id="element-67">
                CON ENTRENA EN CASA <span className="text-green-500" data-id="element-68">✅</span>
              </h4>
            </div>
          </div>

          <div className="divide-y divide-dark-border" data-id="element-69">
            {comparisons.map((row, i) => <div key={i} className="grid grid-cols-2" data-id="element-70">
                <div className="p-4 md:p-6 border-r border-dark-border flex items-center gap-3 text-gray-400" data-id="element-71">
                  <X className="w-5 h-5 text-red-500 shrink-0" data-id="element-72" />
                  <span className="text-sm md:text-base" data-id="element-73">{row.bad}</span>
                </div>
                <div className="p-4 md:p-6 bg-brand/5 flex items-center gap-3 text-white font-medium" data-id="element-74">
                  <Check className="w-5 h-5 text-green-500 shrink-0" data-id="element-75" />
                  <span className="text-sm md:text-base" data-id="element-76">{row.good}</span>
                </div>
              </div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-77">
          <h3 className="text-2xl font-bold text-white mb-8" data-id="element-78">
            RESULTADOS QUE PUEDES EMPEZAR A VER EN MENOS DE 90 DÍAS
          </h3>
          <div className="flex flex-wrap justify-center gap-4" data-id="element-79">
            {results.map((res, i) => <div key={i} className="flex items-center gap-2 bg-dark-lighter px-4 py-2 rounded-full border border-dark-border" data-id="element-80">
                <Check className="w-4 h-4 text-green-500" data-id="element-81" />
                <span className="text-sm font-medium text-gray-200" data-id="element-82">{res}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}